import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AmDurationPipe } from '../../../_shared/pipes/dayjs-amDuration.pipe';
import { SharedModule } from '../../../_shared/shared.module';

import { PaperNamePipe } from './../../../_shared/pipes/paper-name.pipe';
import { ComponentModule } from './../../components/component.module';
import { TelemedicineComponent } from './telemedicine/telemedicine.component';
import { TelmChatPortletComponent } from './telm-chat/telm-chat-portlet/telm-chat-portlet.component';
import { TelmChatComponent } from './telm-chat/telm-chat.component';
import { TermCardComponent } from './term-card/term-card.component';
import { VideoComponent } from './video/video.component';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        FileUploadModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentModule,
        AmDurationPipe,
        SharedModule,
        VideoComponent,
        TelemedicineComponent,
        TermCardComponent,
        TelmChatComponent,
        TelmChatPortletComponent,
    ],
    exports: [TelemedicineComponent, TermCardComponent, TelmChatComponent, TelmChatPortletComponent],
    providers: [PaperNamePipe],
})
export class TelemedicineModule {}
